import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { commaFormatNumber } from '@Utils/String';
import AvailableRelativeContextsList from '../AvailableRelativeContextsList';
import { mapContextToTitle } from '../ResultToolbarConstants';

import './ContextsSwitcher.scss';

function ContextsSwitcher(props) {
  const { className, activeBreadCrumbContext, totalResult } = props;

  return (
    <div className={className} aria-label="Number of search results">
      <h1 className="result-toolbar-context-switcher-title e2e-results-title u-els-font-size-h3">
        {commaFormatNumber(totalResult || '')}
        &nbsp;
        <span className="result-toolbar-context-switcher-title-current">{mapContextToTitle[activeBreadCrumbContext]}</span>
      </h1>

      <AvailableRelativeContextsList {...props} />
    </div>
  );
}

ContextsSwitcher.propTypes = {
  activeBreadCrumbContext: PropTypes.oneOfType([PropTypes.string, PropTypes.oneOf([null])]),
  totalResult: PropTypes.number,
};

export default memo(ContextsSwitcher);
